import type { Designer } from "@wix/ambassador-picasso-editor-v1-designer/types";
import { getDesignerTranslationKey } from "@wix/picasso-common";
import {
  NEW_DESIGNER_MODAL_EXPERIMENT,
  DESIGNER_NAME_TRANSLATION_KEY_SUFFIX,
} from "../consts";
import type { TFunction } from "react-i18next";
import type Experiments from "@wix/wix-experiments";

export const getDesignerName = (
  designer: Designer | undefined,
  experiments: Experiments,
  t: TFunction,
): string => {
  const isNewDesignerModalEnabled: boolean = experiments.enabled(
    NEW_DESIGNER_MODAL_EXPERIMENT,
  );

  let designerName: string = designer?.name ?? "";

  if (isNewDesignerModalEnabled) {
    const designerIdentifier = designer?.styleTags?.[0];
    const designerTranslationKey: string | undefined =
      designerIdentifier &&
      `${getDesignerTranslationKey(designer)}${DESIGNER_NAME_TRANSLATION_KEY_SUFFIX}`;

    if (designerTranslationKey) {
      designerName = t(designerTranslationKey);
    }
  }

  return designerName;
};
